import { combineReducers } from 'redux'
import { createReducer } from 'helpers/ReducerUtil'
import {
  UPDATE_TEXT,
  UPDATE_LICENSE,
  UPDATE_MESSAGE,
  UPDATE_TOGGLE
} from './constants'

const updateText = (prev, { text }) => {
  return text
}
const updateToggle = (prev, {toggle}) => {
    return toggle
}

const updateLicense = (prev, { license }) =>{
  return license
} 

const updateMessage = (prev, {hint}) => {
  return hint
}


const updateLicenseReducer = createReducer(null, {
  [UPDATE_LICENSE]: updateLicense
})

const updateTextReducer = createReducer('', {
  [UPDATE_TEXT]: updateText,
})

const updateToggleReducer = createReducer(false, {
    [UPDATE_TOGGLE]: updateToggle,
})

const updateMessageReducer = createReducer('', {
  [UPDATE_MESSAGE]: updateMessage,
})


export default combineReducers ({
  text: updateTextReducer,
  license: updateLicenseReducer,
  toggle: updateToggleReducer,
  hint: updateMessageReducer
})


